<template>
  <div class="product-regcnt">
    <header class="inner-header">
      <backIcon />
      <h2>
        {{ $t("Enter Ad Details") }}
      </h2>
    </header>

    <section class="mid-cnt">
      <div class="fomr-box">
        <div class="field-row">
          <label class="text-label">{{ $t("Title") }}</label>
          <input
            type="text"
            name="title"
            value=""
            class="input-style"
            placeholder="Enter Title"
            v-model="title"
            @keyup="(event) => handleInputChnage(event)"
          />
          <!-- v-model="title" -->
          <span class="error-msg" v-if="formError.title">{{
            formError.title
          }}</span>
          <div class="note-msg">
            {{ $t("50 character left") }}
          </div>
        </div>

        <div class="grid-block">
          <div class="grid-col">
            <div class="field-row">
              <div class="date">
                <label class="text-label" for="">
                  {{ $t("Start Date") }}
                </label>
                <!-- <span>
              <datetime  v-model="startDate" type="datetime" id="222" />
            </span> -->
                <datepicker
                  :value="startDate"
                  v-model="startDate"
                  :disabledDates="disabledDates"
                ></datepicker>
              </div>
            </div>
          </div>
          <div class="grid-col">
            <div class="field-row">
              <div class="date">
                <label class="text-label" for=""> {{ $t("End Date") }} </label>
                <!-- <span>
              <datetime  v-model="endDate" type="datetime" id="333"/>
              </span> -->
                <datepicker
                  :value="endDate"
                  v-model="endDate"
                  :disabledDates="disabledDates"
                  calendar-class="date-posrgt"
                ></datepicker>
              </div>
            </div>
          </div>
        </div>
        <div class="field-row">
          <label class="text-label">{{ $t("Description") }}</label>
          <textarea
            class="textare-style"
            placeholder="Enter Description"
            name="description"
            v-model="description"
            @keyup="(event) => handleInputChnage(event)"
          ></textarea>
          <!-- v-model="description" -->
          <span class="error-msg" v-if="formError.description">{{
            formError.description
          }}</span>
          <div class="note-msg">
            {{ $t("250 character left") }}
          </div>
        </div>
        <div class="field-row">
          <label class="text-label">{{ $t("Product Image") }}</label>
          <span class="img-preview" v-if="cropped"><img :src="cropped"/></span>
          <vue-croppie
            v-if="fileValue"
            ref="croppieRef"
            :enableOrientation="true"
            :boundary="{ width: '100%', height: '200' }"
            :viewport="{ width: '100%', height: 146, type: 'square' }"
          >
          </vue-croppie>
          <div v-if="fileValue" class="crop-btnbox">
            <button class="button" @click="crop">Crop Image</button>
          </div>
          <div class="input-placebox">
            <input class="inputfile" type="file" @change="croppie" />
            {{ $t("Upload Image") }}
            <span class="icon-Btn">
              <img src="../assets/images/upload-icon.svg" alt="" />
            </span>
          </div>
          <span class="error-msg" v-if="formError.imagePreview">{{
            formError.imagePreview
          }}</span>
        </div>

        <!-- <div class="field-row">
          <label class="text-label">Selling Price</label>
          <div class="pos-relate">
            <input
              type="number"
              name=""
              value=""
              class="input-style"
              placeholder="ex. 20"
              v-model="sellingPrice"
            />
            <span class="text-label">₹</span>
          </div>
          <span class="error-msg">{{ formError.sellingPrice }}</span>
        </div> -->

        <div class="req-list" v-if="mediaType === 4">
          <div class="optionbox">
            <div class="input_radicol">
              <label class="input-check" for="checkbox">
                <input type="checkbox" id="checkbox" v-model="isNameRequired" />
                <span class="text-label">{{ $t("NameRequired") }} </span>
                <span class="checkmark"></span>
              </label>
            </div>
          </div>

          <div class="optionbox">
            <div class="input_radicol">
              <label class="input-check" for="checkbox1">
                <input
                  type="checkbox"
                  id="checkbox1"
                  v-model="isEmailRequired"
                />
                <span class="text-label"> {{ $t("EmailRequired") }} </span>
                <span class="checkmark"></span>
              </label>
            </div>
          </div>

          <div class="optionbox">
            <div class="input_radicol">
              <label class="input-check" for="checkbox2">
                <input
                  type="checkbox"
                  id="checkbox2"
                  v-model="isPhoneNumberRequired"
                />
                <span class="text-label">
                  {{ $t("PhoneNumberRequired") }}
                </span>
                <span class="checkmark"></span>
              </label>
            </div>
          </div>

          <div class="optionbox">
            <div class="input_radicol" for="checkbox3">
              <label class="input-check">
                <input
                  type="checkbox"
                  id="checkbox3"
                  v-model="isPincodeRequired"
                />
                <span class="text-label">{{ $t("PincodeRequired") }} </span>
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>

        <div class="field-row" v-if="mediaType === 1">
          <label class="text-label">{{
            $t("Phone Number (The customer will contact you )")
          }}</label>

          <input
            type="number"
            name="mobileNumber"
            value=""
            class="input-style"
            placeholder="Enter your number"
            v-model="mobileNumber"
            @keyup="(event) => handleInputChnage(event)"
          />
          <!-- v-model="mobileNumber" -->

          <span class="error-msg" v-if="formError.mobileNumber">{{
            formError.mobileNumber
          }}</span>
        </div>

        <div class="field-row">
          <label class="text-label">{{ $t("Action Name") }}</label>
          <div class="pos-relate">
            <select v-model="action" class="select-opt" disabled>
              <option value="WHATS_APP_OPEN">{{
                $t("Chat on WhatsApp")
              }}</option>
              <option value="CALL_START">{{ $t("SMS") }}</option>
              <option value="LINK_OPEN">{{ $t("Link Open") }}</option>
            </select>

            <span class="drop-icon">
              <img src="../assets/images/drop-icon.svg" alt="" />
            </span>
          </div>
        </div>

        <div class="field-row" v-if="action === 'LINK_OPEN'">
          <label class="text-label">{{ $t("Website URL") }}</label>

          <input
            type="text"
            v-if="mediaType === 1"
            name="webUrl"
            value=""
            v-model="webUrl"
            class="input-style"
            placeholder="Enter website link"
            @keyup="(event) => handleInputChnage(event)"
          />
          <label class="text-label" :style="{fontWeight : 'bold' ,fontSize: '14px'}">{{$t('Example')}}: https://abc.com</label>

          <!-- <span> for example: https://google.com , https://mall91.com </span> -->
          <!-- v-model="webUrl" -->
          <span class="error-msg" v-if="formError.webUrl">{{
            formError.webUrl
          }}</span>
        </div>

        <div class="cart-msg">
          <div class="in-textbox">
            <span
              class="text-label"
              :style="{ color: '#ff0000', fontWeight: 'bold' }"
              >{{ $t("Advertisement Cost") }}</span
            >
            <p>
              {{ $t("Rs. 2 (this amount would be deducted from your wallet)") }}
            </p>
          </div>
        </div>
      </div>

      <div class="ftr-form">
        <button :class="disable ? 'btn disable' : 'btn'" @click="createAdd">
          {{ $route.query.detail ? "Update Ad" : $t("Create Ad") }}
        </button>
      </div>
    </section>
    <loadingIcon v-if="loading" />
    <Toaster :dataValue="toasterData" />
  </div>
</template>
<script>
import backIcon from "../components/icons/backIcon";
import { isAlphabet, isMobileNumber } from "../utils/validators";
import { getBase64Url, b64toBlob } from "../utils/helper";
import { SessionHelper } from "../utils/session";
import loadingIcon from "../components/icons/loadingIcon";
import Toaster from "../components/Toaster";
import * as constants from "../utils/constants";
import axios from "axios";
import Vue from "vue";
import VueCroppie from "vue-croppie";
import "croppie/croppie.css"; // import the croppie css manually
Vue.use(VueCroppie);

import Datepicker from "vuejs-datepicker";

export default {
  name: "CreateAdForm",
  components: {
    backIcon,
    loadingIcon,
    Datepicker,
    Toaster,
  },
  mounted() {
    console.log("==this.$route=", this.$store.state.pincodesList);
    this.pincodesList = this.$store.state.pincodesList;
    this.EditFormPreFilledValue();
  },
  data() {
    return {
      webUrl: "",
      mediaType: 1,
      actionApplicationId: null,
      startDate: new Date(),
      endDate: new Date(),
      disabledDates: {},
      title: "",
      description: "",
      sellingPrice: "",
      imagePreview: null,
      imagePreviewBase64: null,
      mobileNumber: "",
      action: null,
      formError: {
        title: null,
        description: null,
        webUrl: null,
        mobileNumber: null,
        imagePreview: null,
      },
      disable: false,
      toasterData: {},
      isNameRequired: false,
      isEmailRequired: false,
      isPhoneNumberRequired: false,
      isPincodeRequired: false,
      loading: false,
      croppieImage: "",
      cropped: null,
      fileValue: null,
      pincodesList: [],
    };
  },
  methods: {
    isAlphabet,
    isMobileNumber,
    EditFormPreFilledValue() {
      const { detail, intent, MediaType } = this.$route.query;
      if (intent) {
        this.action = intent;
      }
      if (MediaType) {
        this.mediaType = Number(MediaType);
      }
      if (detail && detail) {
        this.title = detail.name;
        this.description = detail.description;
        this.startDate = new Date(detail.startDate);
        this.endDate = new Date(detail.endDate);
        this.pincodesList = detail.pincodes;
        if (detail.campaignMedia.length) {
          this.imagePreview = detail.campaignMedia[0].mediaURL;
          this.cropped = detail.campaignMedia[0].mediaURL;
        }
        this.action =
          detail.campaignAction.action || detail.campaignAction.actionURL;
        if (this.action === "LINK_OPEN") {
          this.webUrl = detail.campaignAction.actionURL;
        }
        this.mobileNumber =
          detail.campaignAction.action === "WHATS_APP_OPEN"
            ? detail.campaignAction.whatsAppNumber
            : detail.campaignAction.callNumber;
        if (detail.leadMedia) {
          this.isEmailRequired = detail.leadMedia.isEmailRequired;
          this.isNameRequired = detail.leadMedia.isNameRequired;
          this.isPincodeRequired = detail.leadMedia.isPincodeRequired;
          this.isPhoneNumberRequired = detail.leadMedia.isPhoneNumberRequired;
          this.imagePreview = detail.leadMedia.mediaURL;
          this.cropped = detail.leadMedia.mediaURL;
        }
        if (detail.mediaType) {
          this.mediaType = detail.mediaType;
        }
      }
    },
    handleInputChnage(event) {
      this.disable = false;
      if (event.target.value) {
        this[event.target.name] = event.target.value;
        if (event.target.name === "title") {
          this.formError.title = null;
        }
        if (event.target.name === "description") {
          this.formError.description = null;
        }
      } else {
        this.formError[
          event.target.name
        ] = `${event.target.name} field cannot be blanked`;
      }
    },
    createPayloadLead() {
      if (
        this.title &&
        this.description &&
        this.imagePreview &&
        this.pincodesList.length && 
        new Date(this.startDate).getTime() < new Date(this.endDate).getTime()
      ) {
        const { detail, intent } = this.$route.query;
        let obj = {
          name: this.title,
          description: this.description,
          startDate: new Date(this.startDate).getTime(),
          endDate: new Date(this.endDate).getTime(),
          mediaType: this.mediaType,
          campaignAction: {},
          pincodes: this.pincodesList,
          leadMedia: {
            isNameRequired: this.isNameRequired,
            isEmailRequired: this.isEmailRequired,
            isPhoneNumberRequired: this.isPhoneNumberRequired,
            isPincodeRequired: this.isPincodeRequired,
            mediaURL: this.imagePreview,
          },
        };
        if (detail) {
          (obj.campaignAction["action"] = this.action),
            (obj.campaignAction["actionURL"] = this.webUrl);
          obj["campaignIdentifier"] = detail.campaignIdentifier;
          this.updateAds(obj);
        } else {
          this.dispatchCreateAds(obj);
        }
      } else {
        console.log("=else error==");
        if (this.title === "") {
          this.formError.title = "Title cannot be blanked";
        }
        if (this.description === "") {
          this.formError.description = "Description cannot be blanked";
        }
        if (
          new Date(this.startDate).getTime() ===
          new Date(this.endDate).getTime()
        ) {
          this.toasterData = {
            status: true,
            msg: "Start date can not be equal to end date",
            timeoutMs: "5000",
            color: "#ff6600",
          };
          this.disable = false;
          return;
        }
     
        if (
          new Date(this.startDate).getTime() > new Date(this.endDate).getTime()
        ) {
          this.toasterData = {
            status: true,
            msg: "Start date can not be greater than end date",
            timeoutMs: "5000",
            color: "#ff6600",
          };
          this.disable = false;
          return;
        }
        
        if (!this.pincodesList.length) {
          this.toasterData = {
            status: true,
            msg: "Please enter pincode",
            timeoutMs: "5000",
            color: "#ff6600",
          };
          this.disable = false;
          return;
        }
        if (!this.imagePreview) {
          this.formError.imagePreview = "Please select an image";
        }
        this.toasterData = {
          status: true,
          msg: "Kindly fill up all the field correctly!",
          timeoutMs: "5000",
          color: "#ff6600",
        };
        this.disable = false;
      }
    },
    createPayload() {
      if (
        this.title &&
        this.description &&
        this.imagePreview &&
        this.pincodesList.length &&
        this.mobileNumber &&
        new Date(this.startDate).getTime() < new Date(this.endDate).getTime() &&
        !this.formError.mobileNumber
      ) {
        
        let obj = {
          name: this.title,
          description: this.description,
          startDate: new Date(this.startDate).getTime(),
          endDate: new Date(this.endDate).getTime(),
          campaignAction: {},
          pincodes: this.pincodesList,
          mediaType: this.mediaType,
          campaignMedia: [
            {
              mediaURL: this.imagePreview,
            },
          ],
        };

        switch (this.action) {
          case "WHATS_APP_OPEN":
            (obj.campaignAction["action"] = this.action),
              (obj.campaignAction["whatsAppNumber"] = this.mobileNumber);
            break;
          case "CALL_START":
            (obj.campaignAction["action"] = this.action),
              (obj.campaignAction["callNumber"] = this.mobileNumber);
            break;
          case "LINK_OPEN":
            (obj.campaignAction["action"] = this.action),
              (obj.campaignAction["callNumber"] = this.mobileNumber);
            (obj.campaignAction["actionURL"] = this.webUrl),
              (obj.campaignAction["actionApplicationId"] = null);
            break;
          default:
        }
        const { detail, intent } = this.$route.query;
        if (detail) {
          console.log("=if dispatch edit", obj);
          obj["campaignIdentifier"] = detail.campaignIdentifier;
          this.updateAds(obj);
        } else {
          console.log("===else dispatch normal-", obj);
          if (
            this.action === "LINK_OPEN" &&
            (this.webUrl === "" || this.formError.webUrl)
          ) {
            this.formError.webUrl = "WebUrl cannot be blanked";
            this.disable = false;
            this.toasterData = {
              status: true,
              msg: "Kindly fill up all the field correctly!",
              timeoutMs: "5000",
              color: "#ff6600",
            };
            return;
          }
        this.dispatchCreateAds(obj);
        }
      } else {
        if (this.title === "") {
          this.formError.title = "Title cannot be blanked";
        }
        if (this.description === "") {
          this.formError.description = "Description cannot be  blanked";
        }
        if (
          new Date(this.startDate).getTime() ===
          new Date(this.endDate).getTime()
        ) {
          this.toasterData = {
            status: true,
            msg: "Start date can not be equal to end date",
            timeoutMs: "5000",
            color: "#ff6600",
          };
          this.disable = false;
          return;
        }
        if (
          new Date(this.startDate).getTime() > new Date(this.endDate).getTime()
        ) {
          this.toasterData = {
            status: true,
            msg: "Start date can not be greater than end date",
            timeoutMs: "5000",
            color: "#ff6600",
          };
          this.disable = false;
          return;
        }

        if (!this.pincodesList.length) {
          this.toasterData = {
            status: true,
            msg: "Please enter pincode",
            timeoutMs: "5000",
            color: "#ff6600",
          };
          this.disable = false;
          return;
        }
        if (!this.imagePreview) {
          this.formError.imagePreview = "Please select and crop an image";
        }
        if (this.mobileNumber === "") {
          this.formError.mobileNumber =
            "Mobile Number should contain 10 digits.";
        }
        if (this.action === "LINK_OPEN" && this.webUrl === "") {
          this.formError.webUrl = "WebUrl cannot be blanked";
        }

        this.toasterData = {
          status: true,
          msg: "Kindly fill up all the field correctly!",
          timeoutMs: "5000",
          color: "#ff6600",
        };
        this.disable = false;
      }
    },
    dispatchCreateAds(payload) {
      this.$store
        .dispatch({ type: "AdsCreation", payload: payload })
        .then((data) => {
          console.log("-data-dispatch-", data);
          if (data.httpStatus) {
            this.disable = false;
            this.loading = false;
            if (data.httpStatus === 200) {
              this.$router.replace("/");
              this.$store.commit("PincodeList", []);
            }
            this.toasterData = {
              status: true,
              msg: data.message,
              timeoutMs: "5000",
              color: "#ff6600",
            };
            if (data.message === "Invalid Token") {
              console.log("=token error==");
              SessionHelper.refereshJwtToken();
              if (SessionHelper.getCookie("JWT-TOKEN") !== "null") {
                this.dispatchCreateAds();
              }
            }
          }
        })
        .catch((err) => {
          this.disable = false;
        });
    },
    updateAds(payload) {
      this.$store
        .dispatch({ type: "UpdateAds", payload: payload })
        .then((data) => {
          if (data.httpStatus) {
            this.disable = false;
            this.loading = false;
            if (data.httpStatus === 200) {
              this.$router.replace("/");
            }
            this.toasterData = {
              status: true,
              msg: data.message,
              timeoutMs: "5000",
              color: "#ff6600",
            };
            if (data.message === "Invalid Token") {
              console.log("=token error==");
              SessionHelper.refereshJwtToken();
              if (SessionHelper.getCookie("JWT-TOKEN") !== "null") {
                this.updateAds();
              }
            }
          }
        })
        .catch((err) => {
          this.disable = false;
          console.log("", err.response);
        });
    },
    createAdd() {
      this.disable = true;
      if (this.mediaType === 4) {
        this.createPayloadLead();
      } else {
        this.createPayload();
      }
    },
    async uploadImage(file) {
      let formData = new FormData();
      formData.append("image", file, file.type);
      formData.append("isResizeRequired", true);
      axios
        .post(constants.FILE_UPLOAD_URL, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((data) => {
          this.imagePreview = data.data.mediaVariantDTOs[0].url;
          this.formError.imagePreview = null;
        })
        .catch(() => {
          // toaster(this, this.$t("wentWrongMsg"), "top-left", 2000);
        });
    },
    croppie(e) {
      this.fileValue = e.target.files;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var reader = new FileReader();
      reader.onload = (e) => {
        this.$refs.croppieRef.bind({
          url: e.target.result,
        });
      };

      reader.readAsDataURL(files[0]);
    },
    crop() {
      // Options can be updated.
      // Current option will return a base64 version of the uploaded image with a size of 600px X 450px.
      let options = {
        type: "base64",
        size: { width: 340, height: 150 },
        format: "jpeg",
      };
      this.$refs.croppieRef.result(options, (output) => {
        this.cropped = this.croppieImage = output;
        const signBlob = b64toBlob(this.cropped, "image/png");
        this.uploadImage(signBlob);
      });
    },
  },
  watch: {
    mobileNumber: function(newVal, oldVal) {
      this.formError.mobileNumber = null;
      if (!isMobileNumber(newVal) || !newVal)
        return (this.formError.mobileNumber =
          "Mobile Number should contain 10 digits");
    },
    endDate: function(newVal, oldVal){
      const { detail, intent } = this.$route.query;
      this.disable = false
      var DateOnly
      let msg 
      if(detail){
        DateOnly = new Date(new Date(detail.startDate).toJSON().split("T")[0]).getTime()
        msg = "End should be greater than Created at date"
      }else{
        DateOnly = new Date(new Date().toJSON().split("T")[0]).getTime()
        msg = "End date should greater than Today's date"
      }
      this.endDate = new Date(new Date(newVal).toJSON().split("T")[0]).getTime()
      console.log('=enddate==',this.endDate, DateOnly)
      if(this.endDate <= DateOnly){
        this.disable = true
        this.toasterData = {
            status: true,
            msg: msg,
            timeoutMs: "5000",
            color: "#ff6600",
          };
      }
    },
    startDate: function(newVal, oldVal){
      const { detail, intent } = this.$route.query;
      this.disable = false
      var DateOnly
      let msg 
      if(detail){
        DateOnly = new Date(new Date(detail.startDate).toJSON().split("T")[0]).getTime()
        msg = "Start date can not be less than created at date"
      }else{
        DateOnly = new Date(new Date().toJSON().split("T")[0]).getTime()
        msg = "Start date can be today date or can be future date"
      }
      this.startDate = new Date(new Date(newVal).toJSON().split("T")[0]).getTime()
      console.log('==this.startDate=', this.startDate,DateOnly)
      if(this.startDate < DateOnly){
        this.disable = true
        this.toasterData = {
            status: true,
            msg: msg,
            timeoutMs: "5000",
            color: "#ff6600",
          };
      }
    },
    webUrl: function(newVal, oldVal) {
      var expression = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
      this.webUrl = newVal.toLowerCase();
      var regex = new RegExp(expression);
      if (newVal.match(regex)) {
        if (
          !this.webUrl.includes("http://") &&
          !this.webUrl.includes("https://")
        )
        this.webUrl = "https://" + this.webUrl;
        if(this.webUrl.split('//').length === 2){
          this.formError.webUrl = null
        }else{
          this.formError.webUrl = 
          "Entered url is invalid";
        }
        return;
      } else {
        this.formError.webUrl =
          "Entered url can not be blanked and invalid";
      }
    },
  },
};
</script>
